import { FiltersMap, OptionalFiltersMap } from '@wix/bex-core';
import {
  CursorCollectionConfig,
  useWixPatternsContainer,
  useWixPatternsContainerOverrides,
  useCreateCollection,
} from '@wix/bex-core/react';
import { useState } from 'react';
import { TableGridSwitchState } from '../state/TableGridSwitchState';

/**
 * @deprecated use useTableGridSwitch instead
 */
export function useCursorTableGridSwitch<
  T,
  F extends FiltersMap = OptionalFiltersMap,
>(config: CursorCollectionConfig<T, F>) {
  const createCollection = useCreateCollection();
  const container = useWixPatternsContainer();
  const containerOverrides = useWixPatternsContainerOverrides();

  const [state] = useState(() => {
    const collection = createCollection<T, F>({
      ...config,
      paginationMode: 'cursor',
    });

    return new TableGridSwitchState({
      collection,
      container,
      containerOverrides,
    });
  });

  return state;
}
